import React from 'react';
import { ContactList } from './ContactList.js';
import { VerticalContainer } from './FlexboxContainer.js';
import style from './ContactInfoPeople.scss';
export const ContactInfoPeople = ({ contacts, title, disclaimer }) => (React.createElement("div", { className: style.contactPersons },
    React.createElement("h2", { className: style.contactPersons__heading }, title),
    React.createElement("p", { className: style.contactPersons__info }, disclaimer),
    React.createElement(VerticalContainer, { horizontalAlign: "center" },
        React.createElement(ContactList, { contacts: contacts, maxItemsInRow: 2 }))));
